var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        "show-footer": false,
        title: _vm.$t("message.sendTemplateMessage"),
        className: "meta-template-message-modal",
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("div", { staticClass: "meta-template-modal" }, [
        _c("div", { staticClass: "modal-body" }, [
          _c(
            "div",
            { staticClass: "preview-section" },
            [
              _c("WhatsappMessagePreview", {
                attrs: {
                  templateType: _vm.previewTemplateType,
                  headerMediaType: _vm.previewHeaderMediaType,
                  headerMediaURL: _vm.previewHeaderMediaURL,
                  headerText: _vm.previewHeaderText,
                  body: _vm.previewBody,
                  footer: _vm.previewFooter,
                  buttons: _vm.previewButtons,
                  cards: _vm.previewCards,
                  limitedTimeOffer: _vm.previewLimitedTimeOffer,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "config-section" },
            [
              _c("div", { staticClass: "meta-block" }, [
                _c("div", { staticClass: "meta-item" }, [
                  _c("span", { staticClass: "meta-label" }, [
                    _vm._v("Template"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "meta-value" }, [
                    _vm._v(_vm._s(_vm.template.name)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "meta-item" }, [
                  _c("span", { staticClass: "meta-label" }, [
                    _vm._v("Category"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "meta-value meta-tag" }, [
                    _vm._v(_vm._s(_vm.template.category)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "meta-item" }, [
                  _c("span", { staticClass: "meta-label" }, [
                    _vm._v("Language"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "meta-value" }, [
                    _vm._v(_vm._s(_vm.template.language)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.isCarousel
                ? _c("div", { staticClass: "tabs-container" }, [
                    _c(
                      "div",
                      { staticClass: "tabs-header" },
                      _vm._l(_vm.carouselTabs, function (tab, idx) {
                        return _c(
                          "div",
                          {
                            key: idx,
                            staticClass: "tab-item",
                            class: { active: _vm.activeTab === idx },
                            on: {
                              click: function ($event) {
                                _vm.activeTab = idx
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(tab) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isCarousel
                ? [
                    _vm.isMediaHeader
                      ? _c("div", { staticClass: "config-block" }, [
                          _c("div", { staticClass: "block-header" }, [
                            _c("span", { staticClass: "block-title" }, [
                              _vm._v(
                                "Header " + _vm._s(_vm.headerComponent.format)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "block-hint" }, [
                              _vm._v("Required"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "media-source-selection" }, [
                            _c("label", { staticClass: "radio-option" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.useHeaderUrl,
                                    expression: "useHeaderUrl",
                                  },
                                ],
                                attrs: { type: "radio" },
                                domProps: {
                                  value: false,
                                  checked: _vm._q(_vm.useHeaderUrl, false),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.useHeaderUrl = false
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("Upload Media")]),
                            ]),
                            _vm._v(" "),
                            _c("label", { staticClass: "radio-option" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.useHeaderUrl,
                                    expression: "useHeaderUrl",
                                  },
                                ],
                                attrs: { type: "radio" },
                                domProps: {
                                  value: true,
                                  checked: _vm._q(_vm.useHeaderUrl, true),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.useHeaderUrl = true
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("Use URL")]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.useHeaderUrl
                            ? _c("div", { staticClass: "media-url-input" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.headerParams[0],
                                      expression: "headerParams[0]",
                                    },
                                  ],
                                  staticClass: "param-field",
                                  attrs: {
                                    type: "text",
                                    placeholder:
                                      _vm.getTemplateHeaderAssetUrl() ||
                                      _vm.getHeaderParamPlaceholder(),
                                  },
                                  domProps: { value: _vm.headerParams[0] },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.headerParams,
                                        0,
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.getTemplateHeaderAssetUrl() &&
                                !_vm.headerParams[0]
                                  ? _c("div", { staticClass: "url-hint" }, [
                                      _vm._v(
                                        "\n                                Template has a default media. Leave empty to use it, or enter a custom URL.\n                            "
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _c(
                                "div",
                                { staticClass: "media-area" },
                                [
                                  _vm.media
                                    ? _c(
                                        "div",
                                        { staticClass: "media-uploaded" },
                                        [
                                          _vm.headerComponent.format === "IMAGE"
                                            ? _c("img", {
                                                attrs: {
                                                  src: _vm.media.data,
                                                  alt: "Preview",
                                                },
                                              })
                                            : _vm.headerComponent.format ===
                                              "VIDEO"
                                            ? _c("video", {
                                                attrs: {
                                                  src: _vm.media.data,
                                                  controls: "",
                                                },
                                              })
                                            : _c(
                                                "div",
                                                { staticClass: "doc-preview" },
                                                [
                                                  _c("a-icon", {
                                                    attrs: { type: "file" },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(_vm.media.name)
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "remove-media",
                                              on: { click: _vm.removeMedia },
                                            },
                                            [
                                              _c("a-icon", {
                                                attrs: { type: "close" },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm.getTemplateHeaderAssetUrl()
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "media-uploaded template-media",
                                          },
                                          [
                                            _vm.headerComponent.format ===
                                            "IMAGE"
                                              ? _c("img", {
                                                  attrs: {
                                                    src: _vm.getTemplateHeaderAssetUrl(),
                                                    alt: "Template Media",
                                                  },
                                                })
                                              : _vm.headerComponent.format ===
                                                "VIDEO"
                                              ? _c("video", {
                                                  attrs: {
                                                    src: _vm.getTemplateHeaderAssetUrl(),
                                                    controls: "",
                                                  },
                                                })
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass: "doc-preview",
                                                  },
                                                  [
                                                    _c("a-icon", {
                                                      attrs: { type: "file" },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v("Template Media"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "template-media-badge",
                                              },
                                              [_vm._v("Template Default")]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          { staticClass: "upload-area small" },
                                          [
                                            _c("input", {
                                              attrs: {
                                                type: "file",
                                                accept: _vm.getAcceptType(),
                                              },
                                              on: {
                                                change: _vm.handleFileUpload,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("a-icon", {
                                              attrs: { type: "upload" },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "upload-label" },
                                              [_vm._v("Upload different media")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _c(
                                        "label",
                                        { staticClass: "upload-area" },
                                        [
                                          _c("input", {
                                            attrs: {
                                              type: "file",
                                              accept: _vm.getAcceptType(),
                                            },
                                            on: {
                                              change: _vm.handleFileUpload,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("a-icon", {
                                            attrs: { type: "cloud-upload" },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "upload-label" },
                                            [_vm._v("Click to upload")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "upload-format" },
                                            [_vm._v(_vm._s(_vm.getMediaHint()))]
                                          ),
                                        ],
                                        1
                                      ),
                                ],
                                2
                              ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.headerComponent &&
                    _vm.headerComponent.format === "TEXT" &&
                    _vm.headerParams.length > 0
                      ? _c("div", { staticClass: "config-block" }, [
                          _c("div", { staticClass: "block-header" }, [
                            _c("span", { staticClass: "block-title" }, [
                              _vm._v("Header Variables"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "params-list" },
                            _vm._l(_vm.headerParams, function (param, index) {
                              return _c(
                                "div",
                                { key: "h-" + index, staticClass: "param-row" },
                                [
                                  _c("div", { staticClass: "param-info" }, [
                                    _c("span", { staticClass: "param-idx" }, [
                                      _vm._v(_vm._s(_vm.getPlaceholder(index))),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "param-ctx" }, [
                                      _vm._v(
                                        _vm._s(_vm.getHeaderParamContext(index))
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.headerParams[index],
                                        expression: "headerParams[index]",
                                      },
                                    ],
                                    staticClass: "param-field",
                                    attrs: {
                                      type: "text",
                                      placeholder:
                                        _vm.getHeaderParamPlaceholder(),
                                    },
                                    domProps: {
                                      value: _vm.headerParams[index],
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.headerParams,
                                          index,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.bodyParams.length > 0
                      ? _c("div", { staticClass: "config-block" }, [
                          _c("div", { staticClass: "block-header" }, [
                            _c("span", { staticClass: "block-title" }, [
                              _vm._v("Body Variables"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "params-list" },
                            _vm._l(_vm.bodyParams, function (param, index) {
                              return _c(
                                "div",
                                { key: "b-" + index, staticClass: "param-row" },
                                [
                                  _c("div", { staticClass: "param-info" }, [
                                    _c("span", { staticClass: "param-idx" }, [
                                      _vm._v(_vm._s(_vm.getPlaceholder(index))),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "param-ctx" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getParamContext(
                                            _vm.bodyComponent.text,
                                            index
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.bodyParams[index],
                                        expression: "bodyParams[index]",
                                      },
                                    ],
                                    staticClass: "param-field",
                                    attrs: {
                                      type: "text",
                                      placeholder: "Enter value",
                                    },
                                    domProps: { value: _vm.bodyParams[index] },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.bodyParams,
                                          index,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.buttonParams.length > 0
                      ? _c("div", { staticClass: "config-block" }, [
                          _c("div", { staticClass: "block-header" }, [
                            _c("span", { staticClass: "block-title" }, [
                              _vm._v("Button Variables"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "params-list" },
                            _vm._l(_vm.buttonParams, function (param, index) {
                              return _c(
                                "div",
                                {
                                  key: "btn-" + index,
                                  staticClass: "param-row",
                                },
                                [
                                  _c("div", { staticClass: "param-info" }, [
                                    _c("span", { staticClass: "param-idx" }, [
                                      _vm._v(_vm._s(_vm.getPlaceholder(index))),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "param-ctx" }, [
                                      _vm._v(
                                        _vm._s(_vm.getButtonParamContext(index))
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.buttonParams[index],
                                        expression: "buttonParams[index]",
                                      },
                                    ],
                                    staticClass: "param-field",
                                    attrs: {
                                      type: "text",
                                      placeholder: "Enter value",
                                    },
                                    domProps: {
                                      value: _vm.buttonParams[index],
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.buttonParams,
                                          index,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.limitedTimeOfferComponent
                      ? _c("div", { staticClass: "config-block" }, [
                          _c("div", { staticClass: "block-header" }, [
                            _c("span", { staticClass: "block-title" }, [
                              _vm._v("Limited Time Offer"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "block-hint" }, [
                              _vm._v("Required"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "params-list" }, [
                            _c(
                              "div",
                              { staticClass: "param-row" },
                              [
                                _c("div", { staticClass: "param-info" }, [
                                  _c(
                                    "span",
                                    { staticClass: "param-idx" },
                                    [
                                      _c("a-icon", {
                                        attrs: { type: "calendar" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "param-ctx" }, [
                                    _vm._v("Offer expiration date"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("a-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "show-time": true,
                                    format: "YYYY-MM-DD HH:mm",
                                    placeholder: "Select expiration date",
                                    "disabled-date": _vm.disabledDate,
                                  },
                                  model: {
                                    value: _vm.expirationDate,
                                    callback: function ($$v) {
                                      _vm.expirationDate = $$v
                                    },
                                    expression: "expirationDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.hasAnyParams && !_vm.isMediaHeader
                      ? _c("div", { staticClass: "ready-state" }, [
                          _c(
                            "div",
                            { staticClass: "ready-icon" },
                            [_c("a-icon", { attrs: { type: "check" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "ready-text" }, [
                            _vm._v("Ready to send"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "ready-hint" }, [
                            _vm._v("This template requires no parameters"),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                : [
                    _vm.activeTab === 0
                      ? [
                          _vm.bodyParams.length > 0
                            ? _c("div", { staticClass: "config-block" }, [
                                _c("div", { staticClass: "block-header" }, [
                                  _c("span", { staticClass: "block-title" }, [
                                    _vm._v("Body Variables"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "params-list" },
                                  _vm._l(
                                    _vm.bodyParams,
                                    function (param, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: "b-" + index,
                                          staticClass: "param-row",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "param-info" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "param-idx" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getPlaceholder(index)
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "param-ctx" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getParamContext(
                                                        _vm.bodyComponent.text,
                                                        index
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.bodyParams[index],
                                                expression: "bodyParams[index]",
                                              },
                                            ],
                                            staticClass: "param-field",
                                            attrs: {
                                              type: "text",
                                              placeholder: "Enter value",
                                            },
                                            domProps: {
                                              value: _vm.bodyParams[index],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.bodyParams,
                                                  index,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.bodyParams.length === 0
                            ? _c("div", { staticClass: "ready-state" }, [
                                _c(
                                  "div",
                                  { staticClass: "ready-icon" },
                                  [_c("a-icon", { attrs: { type: "check" } })],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "ready-text" }, [
                                  _vm._v("No variables"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "ready-hint" }, [
                                  _vm._v("Main message has no parameters"),
                                ]),
                              ])
                            : _vm._e(),
                        ]
                      : _vm._l(_vm.carouselCards, function (card, cardIndex) {
                          return _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.activeTab === cardIndex + 1,
                                  expression: "activeTab === cardIndex + 1",
                                },
                              ],
                              key: "card-" + cardIndex,
                            },
                            [
                              _vm.hasCarouselCardHeaderVariable(cardIndex)
                                ? _c("div", { staticClass: "config-block" }, [
                                    _c("div", { staticClass: "block-header" }, [
                                      _c(
                                        "span",
                                        { staticClass: "block-title" },
                                        [
                                          _vm._v(
                                            "Header " +
                                              _vm._s(
                                                _vm.getCarouselCardHeaderFormat(
                                                  cardIndex
                                                )
                                              )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "block-hint" },
                                        [_vm._v("Required")]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "media-source-selection" },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "radio-option" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.carouselCardUseUrl[
                                                      cardIndex
                                                    ],
                                                  expression:
                                                    "carouselCardUseUrl[cardIndex]",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: false,
                                                checked: _vm._q(
                                                  _vm.carouselCardUseUrl[
                                                    cardIndex
                                                  ],
                                                  false
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.carouselCardUseUrl,
                                                    cardIndex,
                                                    false
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v("Upload Media"),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          { staticClass: "radio-option" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.carouselCardUseUrl[
                                                      cardIndex
                                                    ],
                                                  expression:
                                                    "carouselCardUseUrl[cardIndex]",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: true,
                                                checked: _vm._q(
                                                  _vm.carouselCardUseUrl[
                                                    cardIndex
                                                  ],
                                                  true
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.carouselCardUseUrl,
                                                    cardIndex,
                                                    true
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("span", [_vm._v("Use URL")]),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.carouselCardUseUrl[cardIndex]
                                      ? _c(
                                          "div",
                                          { staticClass: "media-url-input" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.carouselCardParams[
                                                      cardIndex
                                                    ].header[0],
                                                  expression:
                                                    "carouselCardParams[cardIndex].header[0]",
                                                },
                                              ],
                                              staticClass: "param-field",
                                              attrs: {
                                                type: "text",
                                                placeholder:
                                                  _vm.getCarouselCardAssetUrl(
                                                    cardIndex
                                                  ) ||
                                                  _vm.getCarouselHeaderParamPlaceholder(
                                                    cardIndex
                                                  ),
                                              },
                                              domProps: {
                                                value:
                                                  _vm.carouselCardParams[
                                                    cardIndex
                                                  ].header[0],
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.carouselCardParams[
                                                      cardIndex
                                                    ].header,
                                                    0,
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _vm.getCarouselCardAssetUrl(
                                              cardIndex
                                            ) &&
                                            !_vm.carouselCardParams[cardIndex]
                                              .header[0]
                                              ? _c(
                                                  "div",
                                                  { staticClass: "url-hint" },
                                                  [
                                                    _vm._v(
                                                      "\n                                        Card has a default media. Leave empty to use it, or enter a custom URL.\n                                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "media-area" },
                                          [
                                            _vm.carouselCardMedia[cardIndex]
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "media-uploaded",
                                                  },
                                                  [
                                                    _vm.getCarouselCardHeaderFormat(
                                                      cardIndex
                                                    ) === "IMAGE"
                                                      ? _c("img", {
                                                          attrs: {
                                                            src: _vm
                                                              .carouselCardMedia[
                                                              cardIndex
                                                            ].data,
                                                            alt: "Preview",
                                                          },
                                                        })
                                                      : _vm.getCarouselCardHeaderFormat(
                                                          cardIndex
                                                        ) === "VIDEO"
                                                      ? _c("video", {
                                                          attrs: {
                                                            src: _vm
                                                              .carouselCardMedia[
                                                              cardIndex
                                                            ].data,
                                                            controls: "",
                                                          },
                                                        })
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "doc-preview",
                                                          },
                                                          [
                                                            _c("a-icon", {
                                                              attrs: {
                                                                type: "file",
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .carouselCardMedia[
                                                                    cardIndex
                                                                  ].name
                                                                )
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "remove-media",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.removeCarouselCardMedia(
                                                              cardIndex
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("a-icon", {
                                                          attrs: {
                                                            type: "close",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              : _vm.getCarouselCardAssetUrl(
                                                  cardIndex
                                                )
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "media-uploaded template-media",
                                                    },
                                                    [
                                                      _vm.getCarouselCardHeaderFormat(
                                                        cardIndex
                                                      ) === "IMAGE"
                                                        ? _c("img", {
                                                            attrs: {
                                                              src: _vm.getCarouselCardAssetUrl(
                                                                cardIndex
                                                              ),
                                                              alt: "Template Media",
                                                            },
                                                          })
                                                        : _vm.getCarouselCardHeaderFormat(
                                                            cardIndex
                                                          ) === "VIDEO"
                                                        ? _c("video", {
                                                            attrs: {
                                                              src: _vm.getCarouselCardAssetUrl(
                                                                cardIndex
                                                              ),
                                                              controls: "",
                                                            },
                                                          })
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "doc-preview",
                                                            },
                                                            [
                                                              _c("a-icon", {
                                                                attrs: {
                                                                  type: "file",
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c("span", [
                                                                _vm._v(
                                                                  "Template Media"
                                                                ),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "template-media-badge",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Template Default"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "upload-area small",
                                                    },
                                                    [
                                                      _c("input", {
                                                        attrs: {
                                                          type: "file",
                                                          accept:
                                                            _vm.getCarouselCardAcceptType(
                                                              cardIndex
                                                            ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleCarouselCardFileUpload(
                                                              $event,
                                                              cardIndex
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("a-icon", {
                                                        attrs: {
                                                          type: "upload",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "upload-label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Upload different media"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              : _c(
                                                  "label",
                                                  {
                                                    staticClass: "upload-area",
                                                  },
                                                  [
                                                    _c("input", {
                                                      attrs: {
                                                        type: "file",
                                                        accept:
                                                          _vm.getCarouselCardAcceptType(
                                                            cardIndex
                                                          ),
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleCarouselCardFileUpload(
                                                            $event,
                                                            cardIndex
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("a-icon", {
                                                      attrs: {
                                                        type: "cloud-upload",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "upload-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Click to upload"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "upload-format",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getCarouselCardMediaHint(
                                                              cardIndex
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                          ],
                                          2
                                        ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.carouselCardParams[cardIndex].body.length > 0
                                ? _c("div", { staticClass: "config-block" }, [
                                    _c("div", { staticClass: "block-header" }, [
                                      _c(
                                        "span",
                                        { staticClass: "block-title" },
                                        [_vm._v("Body Variables")]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "params-list" },
                                      _vm._l(
                                        _vm.carouselCardParams[cardIndex].body,
                                        function (param, paramIndex) {
                                          return _c(
                                            "div",
                                            {
                                              key: "body-" + paramIndex,
                                              staticClass: "param-row",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "param-info" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "param-idx",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getPlaceholder(
                                                            paramIndex
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "param-ctx",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getCarouselCardBodyContext(
                                                            cardIndex,
                                                            paramIndex
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.carouselCardParams[
                                                        cardIndex
                                                      ].body[paramIndex],
                                                    expression:
                                                      "carouselCardParams[cardIndex].body[paramIndex]",
                                                  },
                                                ],
                                                staticClass: "param-field",
                                                attrs: {
                                                  type: "text",
                                                  placeholder: "Enter value",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.carouselCardParams[
                                                      cardIndex
                                                    ].body[paramIndex],
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.carouselCardParams[
                                                        cardIndex
                                                      ].body,
                                                      paramIndex,
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.carouselCardParams[cardIndex].buttons.length >
                              0
                                ? _c("div", { staticClass: "config-block" }, [
                                    _c("div", { staticClass: "block-header" }, [
                                      _c(
                                        "span",
                                        { staticClass: "block-title" },
                                        [_vm._v("Button Variables")]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "params-list" },
                                      _vm._l(
                                        _vm.carouselCardParams[cardIndex]
                                          .buttons,
                                        function (param, paramIndex) {
                                          return _c(
                                            "div",
                                            {
                                              key: "btn-" + paramIndex,
                                              staticClass: "param-row",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "param-info" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "param-idx",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getPlaceholder(
                                                            paramIndex
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "param-ctx",
                                                    },
                                                    [_vm._v("URL suffix")]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.carouselCardParams[
                                                        cardIndex
                                                      ].buttons[paramIndex],
                                                    expression:
                                                      "carouselCardParams[cardIndex].buttons[paramIndex]",
                                                  },
                                                ],
                                                staticClass: "param-field",
                                                attrs: {
                                                  type: "text",
                                                  placeholder: "Enter value",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.carouselCardParams[
                                                      cardIndex
                                                    ].buttons[paramIndex],
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.carouselCardParams[
                                                        cardIndex
                                                      ].buttons,
                                                      paramIndex,
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.carouselCardParams[cardIndex].header
                                .length === 0 &&
                              _vm.carouselCardParams[cardIndex].body.length ===
                                0 &&
                              _vm.carouselCardParams[cardIndex].buttons
                                .length === 0
                                ? _c("div", { staticClass: "ready-state" }, [
                                    _c(
                                      "div",
                                      { staticClass: "ready-icon" },
                                      [
                                        _c("a-icon", {
                                          attrs: { type: "check" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "ready-text" }, [
                                      _vm._v("No variables"),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "ready-hint" }, [
                                      _vm._v("This card has no parameters"),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        }),
                  ],
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-footer" }, [
          _c(
            "button",
            {
              staticClass: "btn-cancel",
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v("Cancel")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-send",
              attrs: { disabled: _vm.sending },
              on: { click: _vm.sendMessage },
            },
            [
              _vm.sending
                ? _c("a-spin", { attrs: { size: "small" } })
                : [
                    _c("a-icon", { attrs: { type: "send" } }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Send")]),
                  ],
            ],
            2
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }